// Client-side mirror of the API's product-image rules (CreateProductValidator,
// ProductValidation settings), so a file the create would refuse is named
// before the round-trip instead of failing the whole save.

// ProductValidation:AllowedImageTypes as the deploy delivers it
// (deploy-env-template.yml). SVG is not here: it was dropped from the
// allow-list (IN-15). The API compares the browser-reported content type
// exactly, so a file with no type is refused too.
export const ACCEPTED_IMAGE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/gif",
    "image/bmp",
    "image/webp",
];

// ProductValidation:MaxImageSizeMB (EnvironmentConfig.md: 2). The API refuses
// a file LARGER than this; one of exactly this size is accepted.
export const MAX_IMAGE_MB = 2;
const MAX_IMAGE_BYTES = MAX_IMAGE_MB * 1024 * 1024;

// The message for a file the API would refuse, naming the file and the
// reason, or null when it is acceptable.
export const productImageError = (file: File): string | null => {
    if (!ACCEPTED_IMAGE_TYPES.includes(file.type)) {
        return `${file.name} was not added: it must be a JPG, PNG, GIF, BMP or WebP image.`;
    }

    if (file.size > MAX_IMAGE_BYTES) {
        return `${file.name} was not added: it is larger than ${MAX_IMAGE_MB} MB.`;
    }

    return null;
};
